export default [
  "半导体终端产品制造商",
  "电子生产服务/原始设计制造商",
  "半导体元器件供应商",
  "半导体生产设备供应商",
  "半导体组装/系统供应商",
  "代理商/分销商/经销商",
  "半导体材料供应商",
  "科研/协会/教育",
  "行业媒体",
  "公共行政机构/职能部门",
  "其他",
];
